<vex-page-layout>

  <div class="container-fluid p-6 m-6 card flex flex-col" [ngClass]="books.length > 0 ? '' : 'h-dynamic'">
    <div class="w-full">
      <div class="w-full flex items-center mb-8 relative">
        <!-- Logo on Left -->
        <div class="absolute left-0">
          <img
            src="https://arniuniversity.edu.in/assets/img/icons/favicon.ico"
            alt="Arni University Logo"
            class="h-16 w-auto"
          />
        </div>

        <!-- Text in Center -->
        <div class="flex-1 text-center">
          <h1 class="text-3xl font-bold text-green-700">ARNI UNIVERSITY</h1>
          <h2 class="text-xl font-semibold text-gray-800">LIBRARY</h2>
          <p class="mt-1 text-sm font-medium tracking-wide text-gray-600 uppercase">
            Online Public Access Catalog
          </p>
        </div>
      </div>


      <div class="mb-6" *ngIf="(!books || books.length === 0) && pageExtras.showImage">
        <img src="assets/images/search-book.png" class="m-auto w-[300px] h-auto" alt="search-image"/>
      </div>
      <form [formGroup]="searchForm">
        <div class="p-2 w-[80%] border m-auto subheading-2 rounded-3xl bg-gray-50">
          <input (keyup)="getBooks()" class="w-dynamic rounded-3xl bg-gray-50 outline-none p-2" placeholder="Search..." formControlName="search_key"/>
          <i *ngIf="!pageExtras.isBusy" (click)="get()" class="fa-solid fa-search text-[20px] text-gray-400 cursor-pointer" matTooltip="Search"></i>
          <i *ngIf="pageExtras.isBusy" class="fa-solid fa-spinner fa-spin text-[20px] text-gray-400 cursor-not-allowed"></i>
        </div>
      </form>

      <div class="mt-8" *ngIf="(!books || books.length === 0) && !pageExtras.showImage && !searchForm?.value?.search_key">
        <img src="assets/images/search-book.png" class="m-auto w-[500px] h-auto" alt="search-image"/>
      </div>
    </div>
    <div class="mt-6" *ngIf="books && books.length > 0">
      <div
        class="book-card flex items-start gap-4 bg-white shadow-md rounded-md p-4 mb-4"
        *ngFor="let book of books; let i = index"
      >
        <!-- Book Image -->
        <div class="w-[120px] flex-shrink-0">
          <img
            class="w-[120px] h-[150px] object-cover rounded shadow"
            [src]="book?.images?.length ? baseUrl + book.images[0].partial_url : 'assets/images/no-book-cover.png'"
            alt="Book Cover"
          />
        </div>

        <!-- Book Details -->
        <div class="flex-1">
          <h2 class="text-lg font-bold text-gray-800">{{ book.title }}</h2>
          <p class="text-sm text-gray-700 mt-1">
            <strong>By:</strong> {{ book.author }}
          </p>
          <p class="text-sm text-gray-700 mt-1">
            <strong>Category:</strong> {{ book.category.name }}
          </p>
          <p class="text-sm text-gray-700 mt-1">
            <strong>Library:</strong> {{ book?.library?.name || "-" | titlecase }}
          </p>

          <!-- Action -->
          <div class="mt-3">
            <button
              class="text-[#6752A9] font-semibold hover:underline"
              (click)="toggleDrawer(i)"
            >
              See Details
            </button>
          </div>

          <!-- Sliding Drawer -->
          <div class="sliding-drawer bg-gray-50 rounded mt-3 p-3" [class.open]="openedDrawer === i">
            <div class="flex justify-between items-center">
              <ng-container *ngIf="book?.book_positions?.length > 0; else noData">
                <div class="flex border border-green-800 text-center text-[10px] rounded-sm overflow-hidden">
                  <div class="px-2 py-1 bg-green-800 text-white">Rack No.</div>
                  <div class="px-2 py-1 text-green-800">Accession No.</div>
                  <div class="px-2 py-1 text-green-800">Status</div>
                </div>
              </ng-container>
              <button class="close-btn hover:text-red-600 text-xl" (click)="toggleDrawer(null)">×</button>
            </div>

            <ng-container *ngIf="book?.book_positions?.length > 0; else noData">
              <div class="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-2 mt-2">
                <div
                  class="flex border border-green-800 rounded-sm text-center text-[10px]"
                  *ngFor="let bookPos of slideData"
                >
                  <div class="p-1 w-1/2 bg-green-800 text-white">{{ bookPos?.rack_no }}</div>
                  <div class="p-1 w-1/2 text-green-800 text-bold">{{ bookPos?.accession_no }}</div>
                  <div class="p-1 w-1/2 text-green-800 text-bold">{{ bookPos?.book_status }}</div>
                </div>
              </div>
            </ng-container>

            <ng-template #noData>
              <div class="text-center text-gray-600 mt-3">Details not available.</div>
            </ng-template>

            <!-- Navigation -->
            <div class="flex justify-center w-full mt-2 gap-3">
              <i class="fa-solid fa-circle-chevron-left text-gray-400 text-[16px] cursor-pointer"
                 (click)="showPreviousSlide()" *ngIf="showPrevBtn"></i>
              <i class="fa-solid fa-circle-chevron-right text-gray-400 text-[16px] cursor-pointer"
                 (click)="showNextSlide()" *ngIf="showNextBtn"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid px-5 subheading-2" *ngIf="books && books.length > 0">
    <div class="card p-2 text-center lg:text-end xl:text-start xxl:text-end my-4">
      <mat-paginator
        class="demo-paginator"
        (page)="handlePageEvent($event)"
        [length]="pagination.length"
        [pageSize]="pagination.pageSize"
        [disabled]="pagination.disabled"
        [showFirstLastButtons]="pagination.showFirstLastButtons"
        [pageSizeOptions]="pagination.showPageSizeOptions ? pagination.pageSizeOptions : []"
        [hidePageSize]="pagination.hidePageSize"
        [pageIndex]="pagination.pageIndex"
        aria-label="Select page">
      </mat-paginator>
    </div>
  </div>
</vex-page-layout>
